<template>
  <div
      :style="{'--dropdownMenuWidth':dropdownMenuWidth, '--dropdownMenuLeft': dropdownMenuLeft,'--dropdownMenuTop': dropdownMenuTop,'--borderColor': borderColor}"
      class="vertical ">
    <span @click="onShowModel" style="width:60px" ref="text" :class="active? 'main-color':'third-color'" >{{ ingredientText }}</span>
    <div class="popup-wrap" :id="`dropdown-date-${id}`">
      <van-popup position="center" ref="dropdownMenu" v-model="showPopup" style="background: transparent;"
          class="date-wrap" close-on-click-overlay
          :get-container="`#dropdown-date-${id}`">
        <div class="relative">

        <span class="vertical items-center " style="width:80px;background: white;height:280px" ref="scrollable">
          <span class="text-14px p-1 bg-white w-full"
              @click="onSelect(item,index)"
              v-for="(item,index) in options" :ref="`item-${index}`" :key="index" :class="[item.value === value ? 'date-active': '',item.active ? 'main-color':'third-color']">
            {{ item.text }}
          </span>
        </span>
        </div>
      </van-popup>
    </div>

  </div>
</template>
<script>
import log from "@/util/log";

export default {
  name: "DropdownDate",
  props: {
    id: {
      type:String,
      default: 'month'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeHolder: {
      type: String,
      default: ""
    },
    value: [Number, String],
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showError: {
      type: Boolean,
      default: false
    },
    active: {
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      test: 0,
      dropdownMenuWidth: 0,
      dropdownMenuLeft: 0,
      dropdownMenuTop: 0,
      showPopup: false
    };
  },
  watch: {
    showPopup(val) {
      if (val) {
        const index = this.options.findIndex(item => item.value === this.value)
        this.$nextTick(()=> {
          this.$refs[`item-${index}`][0].scrollIntoView()
        })

      }
    }
  },
  mounted() {
    log(this.showError);
    this.$nextTick(() => {
      // const el = this.$refs.dropdownMenu.$el;
      const top = this.$refs.text.offsetTop;
      const clientWidth = this.$refs.text.clientWidth;
      const offsetLeft = this.$refs.text.offsetLeft;
      console.log(`offset left = ${offsetLeft}`)
      console.log(`offset clientWidth = ${clientWidth}`)
      this.dropdownMenuTop = `${top}px`;
      this.dropdownMenuWidth = `80px`;
      this.dropdownMenuLeft = `${clientWidth / 2 + offsetLeft + 4}px`;
      log(`dropdownMenu = ${clientWidth}`);
      log(`dropdownMenu = ${top}`);
    });
  },
  methods: {
    onShowModel() {
      this.$emit('onshow', true)
      this.showPopup = true;
    },
    onInput(item, optionIndex) {
      this.$refs.dropdownItem.toggle();
      log(item);
      this.$emit("input", item, optionIndex);
    },
    onSelect(item, index) {
      if (!item.active) {
        return
      }
      this.showPopup = false;
      this.$emit("input", item, index);
    }
  },
  computed: {
    ingredientText() {
      if (this.value === "") {
        return this.placeHolder;
      }
      return this.options.find(item => item.value === this.value).text;
    },
    ingredientTextClass() {
      if (this.value === "") {
        return "third-color";
      }
      return "";
    },
    borderColor() {
      if (this.showError) {
        return "red";
      } else {
        return "#E8E8E8";
      }
    }
  }
};
</script>


<style scoped lang="less">
::v-deep .van-dropdown-menu {
  border: unset;

  .van-dropdown-menu__bar {
    background: transparent;
    box-shadow: none;
    height: 32px;
  }

  .van-dropdown-menu__item {
    border: unset;
  }

  .van-dropdown-menu__title {
    flex: 1;
    font-size: 14px;

    &:after {
      border: unset;
    }
  }

  .van-dropdown-menu__title::after {
    right: 20px;
  }


  .van-cell__title {
    text-align: center;
  }
}

::v-deep .van-overlay {
  background-color: transparent;
}

.van-popup--top {
  width: var(--dropdownMenuWidth);
  left: var(--dropdownMenuLeft);
  top: var(--dropdownMenuTop);
}

.van-popup--center {
  width: var(--dropdownMenuWidth);
  left: var(--dropdownMenuLeft);
}

.dropdown-menu-custom {
  background: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 1px #E8E8E8 solid;
  border-left: 1px #E8E8E8 solid;
  border-right: 1px #E8E8E8 solid;
  padding: 10px 0;
  font-size: 14px;

  box-shadow: 1px 1px 1px -1px rgba(0, 0, 0, 0.15);
}

.date-wrap {
  background: white;
  border-radius: 8px;
  box-shadow: 0px 1px 10px 1px rgba(126, 132, 134, 0.302);
}

.date-active {
  background: black;
  color: white;
}
</style>